import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useLoading } from "../../../infra/helpers/alerts";
import { Botao } from "../../../shared/components/Botao";
import { LoadingPage } from "../../../shared/components/LoadingPage";
import { Sidebar } from "../../../shared/components/MenuSidebar/Sidebar";
import { CreateModal } from "../../../shared/components/Modal";
import { ConfirmDeleteModal } from "../../../shared/components/Modal/ConfirmDeleteModal";
import { Navbar } from "../../../shared/components/Navbar";
import { PageHeader } from "../../../shared/components/PageHeader/PageHeader";
import { TableInfo } from "../../../shared/components/Table";

import { IconAdicionar } from "../../../shared/Icons/IconAdicionar";
import { IconVisibility } from "../../../shared/Icons/IconVisibility";
import { SimpleFilter } from "../../../shared/SimpleFilter";
import { FormBotijao } from "../components/Form";
import { VisualizarBotijao } from "../components/ModalVisualizar";
import usePostBotijao from "../hooks/usePostBotijao";
import deleteBotijao from "../queries/deleteBotijao";
import { Botijao, BotijaoModulo } from "../types/Botijao";
import { colunas } from "../util/Colunas";
import Swal from 'sweetalert2'
import { IconBotijao } from "../../../shared/Icons/IconBotijao";
import { useGetBotijoes } from "../hooks/useGetBotijoes";

const pageName = "Botijão";

export function Botijoes() {
  const [visible, setVisible] = useState<boolean>(false);
  const [visibleDelete, setVisibleDelete] = useState(false);
  const [valueInput, setValueInput] = useState<string>("");
  const [search, setSearch] = useState<string>("");
  const [botijao, setBotijao] = useState<Botijao[]>([]);
  const [botijaoId, setBotijaoId] = useState<number>();
  const [page, setPage] = useState<number>(1);
  
  const { register, handleSubmit, reset } = useForm<BotijaoModulo>();

  function resetForm() {
    setVisible(false)
    reset()
  }

  const { mutate: salvarNovoBotijao, isLoading: LoadingButton  } = usePostBotijao(resetForm);
  const { data: botijaoData, isLoading } = useGetBotijoes(search,page);

  useEffect(() => {
    botijaoData && setBotijao(botijaoData.items)
  },[botijaoData])

  useLoading(isLoading);

  function handleVisualizar(id?: number) {
    setBotijaoId(id);
    setVisible(!visible);
  }

  function handleCloseVisualizar() {
    setBotijaoId(undefined);
    setVisible(!visible);
    reset();
  }

  const columns = [
    ...colunas,
    {
      title: "Ações",
      dataIndex: "action",
      key: "action",
      width: 50,
      render: (text: any, record: any, index: any) => {
        return (
          <div className=" flex justify-center gap-3">
            <button
              className="bg-gray-400 hover:bg-primary-hover p-1 text-gray-100 rounded-full"
              onClick={() => handleVisualizar(record.BotijaoId)}
            >
              <IconVisibility width="20" height="20" />
            </button>
          </div>
        );
      },
    },
  ];


  async function onSubmit(data: BotijaoModulo) {
    navigator.onLine && await salvarNovoBotijao(data);
    
    !navigator.onLine && Swal.fire({
      title: 'Sem conexão',
      text: 'Por favor, verifique a sua conexão com a internet e tente novamente.',
      icon: 'error',
      position: 'center',
      confirmButtonText: 'Ok',
      confirmButtonColor: '#f27474'
    })
  }

  async function onDelete() {
    if (botijaoId) {
    
      const result = await deleteBotijao(botijaoId).then((r) => r)
      result?.status === 200 && setVisibleDelete(!visibleDelete)
    }
    setBotijaoId(undefined)
  }

  return (
    <div className="flex flex-row mx-auto">
      <div className="flex flex-row">
        <Sidebar />
        <Navbar />
      </div>
      <div className="flex flex-col pl-[10rem] w-[85%] mx-auto">
        <PageHeader 
          titulo={pageName}
          icon={<IconBotijao width="25"/>}
          componente={
            <div className="flex gap-10">
              <SimpleFilter
                placeholder="Pesquisar Botijão"
                value={valueInput}
                onChange={(e: any) => setValueInput(e.target.value)}
                onClick={() => {
                  setSearch(valueInput);
                  if(valueInput) {
                    setPage(1);
                  }
                }}
                onCancel={() => {
                  setSearch('')
                  setValueInput('')
                }}
              />
              <Botao 
                texto="Novo" 
                icon={<IconAdicionar color="#fff"/>} 
                onClick={() => setVisible(!visible)} 
                className="bg-primary hover:bg-primary-hover text-white"
              />
            </div>
          }
        />
        {
          typeof(botijaoId) === 'number' ? <VisualizarBotijao 
            idBotijao={botijaoId} 
            setIdBotijao={setBotijaoId}
            deleteModal={() => {
              handleVisualizar(botijaoId)
              setVisibleDelete(!visibleDelete)
            }}
            resetForm={resetForm}
            onCancel={handleCloseVisualizar} 
            visible={visible} />
          : <CreateModal
            title="Cadastro de Botijão"
            isModalOpen={visible}
            onCancel={() => setVisible(!visible)}
            onSubmit={handleSubmit(onSubmit)}
            closable
            isLoading={LoadingButton}
          >
            <FormBotijao 
              register={register}
            />
          </CreateModal>
        }

        {!botijaoData ? (
          <div className="h-[80vh] flex justify-center items-center">
            <LoadingPage />
          </div>
        ) : (
          <TableInfo
            dataSource={botijao}
            columns={columns}
            pagination={{
              current: page,
              pageSize: botijaoData?.meta?.itemsPerPage,
              total: botijaoData?.meta?.totalItems,
              onChange(p) {
                setPage(p);
              },
            }}
          />
        )}

        <ConfirmDeleteModal
          isModalOpen={visibleDelete}
          title="Deletar Botijão"
          mensagem="Você tem certeza que desejar excluir este botijão?"
          onDelete={onDelete}
          closeModal={() => {
            setVisibleDelete(!visibleDelete)
            setVisible(!visible);
          }}
        />
      </div>
    </div>
  );
}
